import React, { useEffect, useState } from 'react';

import nurseChatBubblesImage from 'images/illustrations/nurse-chat-bubbles.svg';
import { OnboardingTitle } from 'registration/containers/Onboarding';

import { Checkbox, LABEL_PLACEMENT } from 'shared/components/ihcl/checkbox';
import { Stack } from 'shared/components/ihcl/patterns';
import { styled } from 'shared/components/ihcl/styled';
import { Text } from 'shared/components/ihcl/text';
import { trackClick } from 'shared/helpers/tracking';

import { useOnboardingStepContext } from '../providers/OnboardingStepProvider';
import { useOnboardingVariantContext } from '../providers/OnboardingVariantProvider';
import StickySubmitFooter from './StickySubmitFooter';

const CheckboxWrapper = styled('div', {
  marginTop: '16px',
  paddingLeft: '48px',
  paddingRight: '48px',
});

const ImageWithPadding = styled('img', {
  paddingTop: '40px',
});

const DEFAULT_HEADER = 'Interested in getting matched to permanent work?';
const DEFAULT_BODY_TEXT =
  'We have over 1500+ hospital employers nationwide with thousands of permanent job opportunities that we can match you to.';
const OPEN_TO_PERMANENT_JOB_OPPORTUNITIES =
  'Yes! I’m open to permanent job opportunities';

type OnboardingLicensesProps = {
  bodyText?: string;
  pageTalentProfileKeys: string[];
  title?: string;
};

const OnboardingLicenses = ({
  bodyText = DEFAULT_BODY_TEXT,
  pageTalentProfileKeys,
  title = DEFAULT_HEADER,
}: OnboardingLicensesProps) => {
  const {
    addTalentProfileKeys,
    maybeGoToNext,
    isUpdatingProfile,
    localStepTalentProfile,
    setLocalStepTalentProfile,
  } = useOnboardingStepContext();

  const { intent } = useOnboardingVariantContext();

  const [isChecked, setIsChecked] = useState(true);

  useEffect(() => {
    addTalentProfileKeys(pageTalentProfileKeys);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (Object.keys(localStepTalentProfile).length === 0) {
    return null;
  }

  const submit = () => {
    trackClick('talent.onboarding.submit', {
      Intent: intent,
    });
    maybeGoToNext();
  };

  return (
    <>
      <div>
        <Stack $gapSizing="unit16" $alignItems="center">
          <ImageWithPadding
            alt="Get permanent job matches"
            src={nurseChatBubblesImage}
          />
          <OnboardingTitle $noBottomMargin $noTopMargin>
            {title}
          </OnboardingTitle>
          <Text variant="LabelMedium" color="grayBodyCopy">
            {bodyText}
          </Text>
          <CheckboxWrapper>
            <Checkbox
              checked={isChecked}
              onChange={(e) => {
                setIsChecked(e.target.checked);
                setLocalStepTalentProfile((prevLocalStepTalentProfile) => ({
                  ...prevLocalStepTalentProfile,
                  hiring_activated: e.target.checked,
                }));
              }}
              labelPlacement={LABEL_PLACEMENT.right}
              labelWeight="bold"
            >
              {OPEN_TO_PERMANENT_JOB_OPPORTUNITIES}
            </Checkbox>
          </CheckboxWrapper>
        </Stack>
      </div>

      <StickySubmitFooter
        onClick={submit}
        disabled={isUpdatingProfile}
        isLoading={isUpdatingProfile}
      />
    </>
  );
};

export default OnboardingLicenses;
